import { UserStore } from '@yarmill/types';
import { sortByDate } from './sort-by-date';

export function sortUserStoresByMemberSince(
  a: UserStore,
  b: UserStore
): number {
  return sortByDate(a.internalUser.MemberSince, b.internalUser.MemberSince);
}
